/**
 * Static copy & assets for reviewing aptitude answers (mirrors aptitude.tsx).
 */

export const APTITUDE_A_META = {
  title: "Aptitude Test 1 : Calculation",
  subtitle: "Calculate and enter the missing answer in the box.",
  items: [
    {
      key: "question_b",
      label: "a) 82 − ____ = 62",
      question:
        "What number should replace the blank so that the equation is true? 82 − ? = 62",
    },
    {
      key: "question_h",
      label: "b) 33 ÷ 11 = ____",
      question: "What is the result of 33 ÷ 11?",
    },
  ],
} as const;

export const APTITUDE_B_META = {
  title: "Aptitude Test 2 : Matching the Blocks",
  subtitle:
    "Find the Same Blocks and enter the answer in the box (A, B, C, D).",
  rows: [
    {
      key: "match_q1",
      no: 1,
      question:
        "Which option (A, B, C, or D) shows the same pattern as the question figure?",
      questionImg:
        "https://res.cloudinary.com/dureqzdco/image/upload/v1742615655/Q1-A4_kfo2qw.svg",
      options: {
        A: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615655/Q1-A1_rtg7qo.svg",
        B: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615655/Q1-A2_erink8.svg",
        C: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615656/Q1-A3_fazwne.svg",
        D: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615655/Q1-1_i2l0ep.svg",
      },
    },
    {
      key: "match_q2",
      no: 2,
      question:
        "Which option (A, B, C, or D) shows the same pattern as the question figure?",
      questionImg:
        "https://res.cloudinary.com/dureqzdco/image/upload/v1742615657/Q2-2_qekdww.svg",
      options: {
        A: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615655/Q2-A1_wzqvqj.svg",
        B: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615655/Q2-A2_tgxknk.svg",
        C: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615657/Q2-A3_aodbbs.svg",
        D: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615657/Q2-A4_zjxqbc.svg",
      },
    },
    {
      key: "match_q3",
      no: 3,
      question:
        "Which option (A, B, C, or D) shows the same pattern as the question figure?",
      questionImg:
        "https://res.cloudinary.com/dureqzdco/image/upload/v1742615657/Q3-3_jwuauq.svg",
      options: {
        A: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615657/Q3-A1_p6ilz9.svg",
        B: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615658/Q3-A2_zhjkfz.svg",
        C: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615658/Q3-A3_aq2qol.svg",
        D: "https://res.cloudinary.com/dureqzdco/image/upload/v1742615658/Q3-A4_cl30z4.svg",
      },
    },
  ],
} as const;

export const APTITUDE_C_META = {
  title: "Aptitude Test 3 : IQ Quiz",
  subtitle: "Read the Question and Choose Appropriate Answer.",
  items: [
    {
      key: "iq_q1",
      prompt: "1) How many triangles do you see?",
      image:
        "https://res.cloudinary.com/dureqzdco/image/upload/v1742616626/triangle_fm1aud.svg",
      choices: ["9", "13", "17", "15"],
    },
    {
      key: "iq_q2",
      prompt: "2) 1 kilometer = _______ meters",
      choices: ["1000", "10000", "100", "500"],
    },
    {
      key: "iq_q5",
      prompt:
        "3) If a vehicle number is 7896, which is the largest digit in the number?",
      choices: ["7", "8", "9", "6"],
    },
  ],
} as const;

export const APTITUDE_D_META = {
  title: "Aptitude Test 4 : Japanese Language",
  subtitle:
    "From (1) to (42) in the reference grid, choose one number which matches the same shape as (A) to (L).",
  items: [
    { key: "A", char: "お" },
    { key: "B", char: "ケ" },
    { key: "C", char: "三" },
    { key: "D", char: "め" },
    { key: "E", char: "上" },
    { key: "F", char: "ユ" },
    { key: "G", char: "わ" },
    { key: "H", char: "九" },
    { key: "I", char: "シ" },
    { key: "J", char: "犬" },
    { key: "K", char: "さ" },
    { key: "L", char: "ヤ" },
  ],
} as const;
